module.exports = __webpack_public_path__ + "img/P529205804.174a25ca.jpg";